import {withActions} from 'carmi-host-extensions/src/aspects/withActions'
import {reportError, reportEvent} from '../../utils/wixappsLogger'
import {getDataByPath} from '../../utils/wixappsDataHandler'
import {todoFunctionLibrary} from '../todoAspect/todoAspect'
export const name = 'WixappsCoreAspect'

export const defaultModel = {
    compsInfoToRender: {},
    wixapps: {}
}

export const functionLibrary = {
    getComponentProps: withActions(({setCompInfoToRender, compProps}, compStructure, rootId, propsOverride) => {
        setCompInfoToRender(compStructure.id, {structure: compStructure, props: propsOverride})
        return compProps[compStructure.id]
    }),
    getAppPageUrl: (renderInfo, requireFn, pageId, itemId, itemTitle) => {
        const warmupUtils = requireFn('warmupUtils')
        const pageInfo = {
            pageId,
            title: itemTitle,
            pageAdditionalData: itemId
        }

        return warmupUtils.wixUrlParser.getUrl(renderInfo, pageInfo)
    },
    getLogic: (appPartName, requireFn) => requireFn('wixappsCore').logicFactory.getLogicClass(appPartName),
    wixAppsReportEvent: reportEvent,
    wixAppsReportError: reportError,
    wixAppsGetDataByPath: (wixapps, packageName, path) => getDataByPath(wixapps[packageName], path),
    ...todoFunctionLibrary
}
